var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ITallyExecutionStatus } from "@/types/ceremonies";
import { styled } from "@mui/material/styles";
import { statusColor } from "@/resources/Tally/constants";
import { Chip } from "@mui/material";
import { theme } from "@sequentech/ui-essentials";
var StyledChips = styled("div")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    padding: 1px 7px;\n    flex-direction: row;\n    align-items: center;\n    gap: 4px;\n"], ["\n    display: flex;\n    padding: 1px 7px;\n    flex-direction: row;\n    align-items: center;\n    gap: 4px;\n"])));
export var StatusChip = function (props) {
    var _a;
    var status = props.status;
    return (_jsx(StyledChips, { children: _jsx(Chip, { sx: {
                backgroundColor: statusColor((_a = props.status) !== null && _a !== void 0 ? _a : ITallyExecutionStatus.STARTED),
                color: theme.palette.background.default,
            }, label: (status === null || status === void 0 ? void 0 : status.length) ? status.toUpperCase() : "-" }) }));
};
var templateObject_1;
